import * as React from 'react';
import { SectionBreakRow } from '../../../surveys/SectionBreakRow';
import { IPageFlowElementDesignRowProps } from './DraggablePageFlowElementRow';
import { DraggablePageFlowElementRow2 } from './DraggablePageFlowElementRow2';

export const DraggableSectionBreakRow2 = (props: IPageFlowElementDesignRowProps) => {
	const { pageFlowValidationHelper, element } = props;
	const warnings = pageFlowValidationHelper.PropertyWarnings(element.surveyElementId);
	const errors = pageFlowValidationHelper.PropertyErrors(element.surveyElementId);

	return (
		<DraggablePageFlowElementRow2
			element={props.element}
			index={props.index}
			pageFlowValidationHelper={props.pageFlowValidationHelper}
			onEdit={props.onEdit}
			onDelete={props.onDelete}
		>
			<SectionBreakRow propertyWarnings={warnings} propertyErrors={errors} />
		</DraggablePageFlowElementRow2>
	);
};
